<template>
  <div ref="main">
    <div class="blank-box" id="scroll" ref="container">
      <iframe
        :src="web_content"
        frameborder="0"
        v-if="module_type == 2"
      ></iframe>
      <div style="min-height: 95%" v-if="module_type == 1">
        <van-empty
          :image="require('@/assets/null.svg')"
          v-if="web_content == ''"
        />
        <div class="content-wrapper" ref="contentWrapper">
          <div class="blank" ref="content" v-html="web_content"></div>
        </div>
      </div>
      <Support v-if="module_type == 1"></Support>
    </div>
    <sideBar></sideBar>
  </div>
</template>

<style lang="less" scoped>
/deep/.van-empty,
/deep/.van-loading {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
}
/deep/.van-empty {
  width: 100%;
  .van-empty__image {
    width: 300px;
    height: 300px;
  }
}
/deep/.van-loading {
  top: 45%;
}
iframe {
  width: 100%;
  height: 100%;
  overflow: auto;
}

.blank-box {
  // background: #000; // 统一背景色防止露出黑边
  height: 100%;
  box-sizing: border-box;
  word-break: break-all;
  overflow: auto;
  touch-action: pinch-zoom !important;
  transform-origin: center center;
}
.content-wrapper {
  width: 100%;
  height: 100%;
  overflow: auto;
  will-change: transform;
  transform-style: preserve-3d;
  background: #fff; // 内容区域背景防止黑边
}
.blank {
  transition: transform 0.1s ease;
  transform-origin: center center;
  font-size: 0.14rem;
  /deep/table{
      border-top: 1px solid #ccc;
    border-left: 1px solid #ccc;
  }
  /deep/table tbody th{
    border-bottom: 2px solid #ccc;
    text-align: center;
    background-color: #f1f1f1;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
  }
  /deep/table tbody td,
  /deep/table tbody td{
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    padding: 3px 5px;
    min-height: 30px;
  }
}
</style>

<script>
import sideBar from "@/components/sidebar";
import Support from "@/components/support";
export default {
  components: {
    sideBar,
    Support,
  },
  data() {
    return {
      web_content: "",
      module_type: 1,
      scale: 1,
      maxScale: 2,
      minScale: 1,
      offsetX: 0,
      offsetY: 0,
      isDragging: false,
      dragStartX: 0,
      dragStartY: 0,
      lastTouchDistance: 0,
      touchCenterX: 0,
      touchCenterY: 0,
      contentWidth: 0,
      contentHeight: 0,
      containerWidth: 0,
      containerHeight: 0,
      minX: 0,
      maxX: 0,
      minY: 0,
      maxY: 0,
    };
  },
  mounted() {
    this.initTouchEvent();
    this.setInitialTransformOrigin();
    window.addEventListener('resize', this.handleResize);
    this.checkOrientation();
    window.addEventListener('orientationchange', this.checkOrientation);
  },
  methods: {
    checkOrientation() {
      this.isLandscape = (window.orientation === 90 || window.orientation === -90);
      if(this.isLandscape){
        this.$refs.main.style.maxWidth = '100%';
      }else{
        this.$refs.main.style.maxWidth = '420px';

      }
    },
    initTouchEvent() {
      const container = this.$refs.container;
      const content = this.$refs.content;
      
      this.updateContentSize();
      
      container.addEventListener('touchstart', (e) => {
        if (e.touches.length === 2) {
          // 仅记录状态，不重置 scale 或 offset
          this.lastTouchDistance = Math.hypot(
            e.touches[0].clientX - e.touches[1].clientX,
            e.touches[0].clientY - e.touches[1].clientY
          );
          this.startScale = this.scale;
          
          // 记录初始 content 位置
          const content = this.$refs.content;
          const rect = content.getBoundingClientRect();
          this.contentStartLeft = rect.left;
          this.contentStartTop = rect.top;
          
          // 记录初始缩放中心点，后续缩放中不再改变
          this.touchCenterX = (e.touches[0].clientX + e.touches[1].clientX) / 2;
          this.touchCenterY = (e.touches[0].clientY + e.touches[1].clientY) / 2;
          
          // 一次性计算缩放中心点并设置
          const centerX = this.touchCenterX - this.contentStartLeft;
          const centerY = this.touchCenterY - this.contentStartTop;
          content.style.transformOrigin = `${centerX}px ${centerY}px`;
        } else if (e.touches.length === 1) {
          this.dragStartX = e.touches[0].clientX;
          this.dragStartY = e.touches[0].clientY;
          
          if(this.scale != 1){
            this.isDragging = true;
          }
        }
      });

      container.addEventListener('touchmove', (e) => {
        if (e.touches.length === 2) {
          e.preventDefault();
          requestAnimationFrame(() => {
            const currentDistance = Math.hypot(
              e.touches[0].clientX - e.touches[1].clientX,
              e.touches[0].clientY - e.touches[1].clientY
            );
            
            let newScale = this.startScale * (currentDistance / this.lastTouchDistance);
            
            if (newScale > this.maxScale) newScale = this.maxScale;
            if (newScale < this.minScale) newScale = this.minScale;
            
            const content = this.$refs.content;
            // 使用 touchstart 时记录的 content 初始位置来计算缩放中心
            const centerX = this.touchCenterX - this.contentStartLeft;
            const centerY = this.touchCenterY - this.contentStartTop;
            
            // 计算新的偏移量以保持中心点不变
            this.offsetX = centerX - (centerX * newScale / this.scale);
            this.offsetY = centerY - (centerY * newScale / this.scale);
            
            this.scale = newScale;
            
            // 使用 Math.round 提高坐标精度
            this.offsetX = Math.round(this.offsetX * 100) / 100;
            this.offsetY = Math.round(this.offsetY * 100) / 100;
            
            this.applyTransform();
            this.updateContentSize();
            this.updateBounds(); // 每次缩放后更新边界
          });
        } else if (e.touches.length === 1 && this.isDragging) {
          const deltaX = e.touches[0].clientX - this.dragStartX;
          const deltaY = e.touches[0].clientY - this.dragStartY;
          
          this.offsetX += deltaX / this.scale;
          this.offsetY += deltaY / this.scale;
          
          this.dragStartX = e.touches[0].clientX;
          this.dragStartY = e.touches[0].clientY;
          
          // 使用 Math.round 提高坐标精度
          this.offsetX = Math.round(this.offsetX * 100) / 100;
          this.offsetY = Math.round(this.offsetY * 100) / 100;
          
          this.applyTransform();
          this.updateContentSize();
          this.updateBounds(); // 每次拖动后更新边界
          
          e.preventDefault();
        }
      }, { passive: false });

      container.addEventListener('touchend', () => {
        this.isDragging = false;
        // 清理状态，但不重置 scale
        this.contentStartLeft = 0;
        this.contentStartTop = 0;
        this.touchCenterX = 0;
        this.touchCenterY = 0;
        if(this.scale == 1){
          this.$refs.contentWrapper.style.transform = `scale(1) translate(0px, 0px)`;
        }
      });
    },
    
    applyTransform() {
      const wrapper = this.$refs.contentWrapper;
      if (wrapper) {
        this.updateBounds();
        
        wrapper.style.transform = `scale(${this.scale}) translate(${this.offsetX}px, ${this.offsetY}px)`;
      }
    },
    
    updateContentSize() {
      const content = this.$refs.content;
      if (content) {
        const rect = content.getBoundingClientRect();
        this.containerWidth = rect.width;
        this.containerHeight = rect.height;
        
        this.contentWidth = rect.width;
        this.contentHeight = rect.height;
      }
    },
    
    updateBounds() {
      const wrapper = this.$refs.contentWrapper;
      if (wrapper) {
        const rect = wrapper.getBoundingClientRect();
        const containerRect = this.$refs.container.getBoundingClientRect();

        // 计算缩放后的真实内容尺寸
        const contentWidth = rect.width * this.scale;
        const contentHeight = rect.height * this.scale;
        const containerWidth = containerRect.width;
        const containerHeight = containerRect.height;

        // 计算最大可拖动范围
        const maxX = contentWidth - containerWidth;
        const maxY = contentHeight - containerHeight;

        // 允许内容在水平和垂直方向上完整拖动
        this.offsetX = Math.max(-maxX, Math.min(this.offsetX, maxX));
        this.offsetY = Math.max(-maxY, Math.min(this.offsetY, maxY));
      }
    },
    
    setInitialTransformOrigin() {
      const content = this.$refs.content;
      if (content) {
        const rect = content.getBoundingClientRect();
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        content.style.transformOrigin = `${centerX}px ${centerY}px`;
      }
    },
    
    handleResize() {
      this.updateContentSize();
      this.setInitialTransformOrigin();
      this.applyTransform();
    }
  },
  created() {
    this.$route.query.module_type == 2 ? (this.module_type = 2) : "";
    this.module_type == 1 ? (this.web_content = JSON.parse(window.sessionStorage.getItem("module_value")).web_content)
      : (this.web_content = JSON.parse(window.sessionStorage.getItem("module_value")).off_site_links);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
     window.removeEventListener('orientationchange', this.checkOrientation);
  }
};
</script>